import { memo, useCallback } from 'react'

import ButtonGroup from 'components/Reporting/Overview/FilterBuilder/ButtonGroup'
import SaveFiltersBtn from 'components/Reporting/Overview/FilterBuilder/FilterSet/SaveButton/SaveFiltersBtn'
import { useAppSelector } from 'redux/Hook'

type FilterSet = {
  filterSetName?: string
  onSaveFilterSet?: (
    inputRef: any,
    selectedFilters: any,
    savedFilterProps: any,
  ) => void
  handleRenameSelection?: (
    filterId: string,
    filterName: string,
    inputRef: any,
  ) => void
  handleDeleteSelection?: (inputRef: any, selectedFilters: any) => void
  filterSetResult?: any
  handleMenuItemClick?: (event: any, index: number) => void
  selectedIndex?: number
}

// we are keeping the button and save filter as a single unit , to make sure
// that if in future we get it behind toggle for some page we can rewstrict from one place
const FilterSet = ({
  filterSetName,
  onSaveFilterSet,
  filterSetResult,
  handleMenuItemClick,
  handleRenameSelection,
  handleDeleteSelection,
  selectedIndex,
}: FilterSet) => {
  const {
    features: {
      features: {
        enable_participant_page_hub_filters: { enabled = false } = {},
      } = {},
    } = {},
  } = useAppSelector((state) => state)
  const Component: any = useCallback(() => {
    switch (true) {
      case filterSetName === 'saveBtn':
        return (
          <SaveFiltersBtn
            onSaveFilterSet={onSaveFilterSet}
            selectedIndex={selectedIndex}
            filterSetResult={filterSetResult}
          />
        )
      case filterSetName === 'buttonGroup':
        return (
          <ButtonGroup
            filterSetResult={filterSetResult}
            handleMenuItemClick={handleMenuItemClick}
            handleRenameSelection={handleRenameSelection}
            handleDeleteSelection={handleDeleteSelection}
            selectedIndex={selectedIndex}
          />
        )

      default:
        return
    }
  }, [filterSetResult, selectedIndex])

  return enabled ? <Component /> : null
}

export default memo(FilterSet)
